import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import AudioPlayer from 'components/audio/AudioPlayer';
import AuthService from 'services/auth.service';
import api from 'services/axiosConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

interface AudioModalProps {
  show: boolean;
  onHide: () => void;
  audioSrc: string;
  customer: string;
  calldata: string;
  campaignId: number;
  callId: string;
}

const AudioModal: React.FC<AudioModalProps> = ({
  show,
  onHide,
  audioSrc,
  customer,
  calldata,
  campaignId,
  callId
}) => {
  const currentUser = AuthService.getCurrentUser();
  const isAdmin = currentUser?.roles.some(
    (role: string) =>
      role === 'SYSTEMADMIN' || role === 'OPSADMIN' || role === 'QAADMIN'
  );

  const handleDownload = async () => {
    try {
      const response = await api.post(
        '/audio/download',
        { callfilepath: audioSrc, callid: callId },
        { responseType: 'blob' }
      );

      // Crear un objeto URL para el blob
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Crear un elemento <a> temporal
      const link = document.createElement('a');
      link.href = url;

      // Generar nombre del archivo
      const fileName = `${customer}_${calldata}_${callId}.wav`;
      link.setAttribute('download', fileName);

      // Añadir el link al documento
      document.body.appendChild(link);

      // Simular click para iniciar la descarga
      link.click();

      // Limpiar
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Error downloading audio:' + error);
    }
  };

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Call Listening</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center p-0">
          <AudioPlayer
            customer={customer}
            phone={calldata}
            audioSrc={audioSrc}
            campaignId={campaignId}
            callId={callId}
          />
        </Modal.Body>
        <Modal.Footer>
          {isAdmin && (
            <Button variant="link" onClick={handleDownload} className="me-2">
              <FontAwesomeIcon icon={faDownload} className="me-2 fs-9" />
              Download Audio
            </Button>
          )}
          <Button variant="primary" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AudioModal;
